import { X } from "@/components/ui/icons";
import { Pressable, Text, View } from "react-native";

import { useThemeColors } from "@/theme/theme";

const CAPTION_CLASS = "min-w-0 flex-1 text-xs font-body text-muted-foreground";

/**
 * The one-line arrival note on the customer browse page (#466), explaining the page under the
 * search box.
 *
 * It is dismissible (persisted via `useBrowseIntroDismissed`) so a returning customer is not
 * greeted on every scan. It is a caption rather than a card so it does not push the vendor's stock
 * down the first screen.
 */
export function BrowseIntro(
  { stocked, onDismiss }: { stocked: boolean; onDismiss: () => void; },
) {
  const c = useThemeColors();
  return (
    <View className="flex-row items-center gap-2">
      {stocked
        ? (
          <Text className={CAPTION_CLASS}>
            Tap <Text className="font-semibold text-foreground">+</Text>{" "}
            on any card to build a list to hand the seller.
          </Text>
        )
        : (
          // An empty table has no "+" to tap, so the note orients the visitor without that step.
          <Text className={CAPTION_CLASS}>
            This is the Vendor's live table — cards appear here as they list them.
          </Text>
        )}
      {
        /* A 44pt frame rather than hitSlop: on the customer web host, `react-native-web`'s
        Pressable ignores `hitSlop`, so the 16pt glyph alone would fail WCAG 2.5.8. */
      }
      <Pressable
        onPress={onDismiss}
        accessibilityRole="button"
        accessibilityLabel="Dismiss intro"
        className="-my-3 h-11 w-11 items-center justify-center"
      >
        <X size={16} color={c.subtle} />
      </Pressable>
    </View>
  );
}
